export const mapStateToProps = state => ({
  token: state.auth.token,
  meetingId: state.meeting.meetingId,
  hasMeetingStarted: state.meeting.hasMeetingStarted,
  hasMeetingEnded: state.meeting.hasMeetingEnded,
  externalMeetingId: state.meeting.connectingVideoId,
  name: state.meeting.name,
  meetingTitle: state.meeting.title,
  isPasswordAccessEnabled: state.meeting.isPasswordAccessEnabled,
  isPasswordAccessEnabled: state.meeting.isPasswordAccessEnabled,
  isPasswordVerified: state.meeting.isPasswordVerified,
  recordingStatus: state.meeting.recordingStatus,
});

export const mapDispatchToProps = () => ({
});
